package repdb

import com.ustadmobile.door.`annotation`.ReplicateEntity
import com.ustadmobile.door.`annotation`.Trigger
import com.ustadmobile.door.ext.DoorDatabaseMetadata
import com.ustadmobile.door.replication.ReplicationEntityMetaData
import com.ustadmobile.door.replication.ReplicationFieldMetaData
import kotlin.Boolean
import kotlin.Int
import kotlin.LazyThreadSafetyMode
import kotlin.String
import kotlin.collections.List
import kotlin.collections.Map
import kotlin.reflect.KClass

public class RepDb_DoorMetadata : DoorDatabaseMetadata<RepDb>() {
  override val dbClass: KClass<RepDb>
    get() = RepDb::class

  override val hasReadOnlyWrapper: Boolean
    get() = true

  override val version: Int
    get() = 1

  override val allTables: List<String> = listOf("RepEntity", "DoorNode", "RepEntityWithAttachment",
      "SyncNode", "CompositePkEntity", "OutgoingReplication")


  override val replicateEntities: Map<Int, ReplicationEntityMetaData> by
      lazy(LazyThreadSafetyMode.NONE) {
        mapOf<Int, ReplicationEntityMetaData>(
        500 to ReplicationEntityMetaData(tableId = 500, 
        entityTableName = "RepEntity", 
        receiveViewName = "RepEntity_ReceiveView", 
        entityPrimaryKeyFieldNames = listOf("rePrimaryKey",),
        entityVersionIdFieldName = "reLastChangeTime", 
        entityFields = listOf(
          ReplicationFieldMetaData(
            fieldName = "reLastChangedBy",
            dbFieldType = -5,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "reLastChangeTime",
            dbFieldType = -5,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "reNumField",
            dbFieldType = 4,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "reString",
            dbFieldType = -1,
            nullable = true,
          ),
          ReplicationFieldMetaData(
            fieldName = "reBoolean",
            dbFieldType = 16,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "rePrimaryKey",
            dbFieldType = -5,
            nullable = false,
          ),
        )
        ,
        batchSize = 1_000,
        remoteInsertStrategy = ReplicateEntity.RemoteInsertStrategy.INSERT_INTO_RECEIVE_VIEW,
        triggers = listOf(
          Trigger(
            name = "repent_remote_insert",
            order = Trigger.Order.INSTEAD_OF,
            events = arrayOf(Trigger.Event.INSERT,),
            on = Trigger.On.RECEIVEVIEW,
            sqlStatements = arrayOf(
              """
              |REPLACE INTO RepEntity(rePrimaryKey, reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean)
              |                       VALUES (NEW.rePrimaryKey, NEW.reLastChangedBy, NEW.reLastChangeTime, NEW.reNumField, NEW.reString, NEW.reBoolean)
              |                /*psql ON CONFLICT(rePrimaryKey) DO UPDATE
              |                   SET reLastChangedBy = EXCLUDED.reLastChangedBy,
              |                       reLastChangeTime = EXCLUDED.reLastChangeTime,
              |                       reNumField = EXCLUDED.reNumField,
              |                       reBoolean = EXCLUDED.reBoolean,
              |                       reString = EXCLUDED.reString
              |                       */
              |                       
              |            
              """.trimMargin(),
            ),
            postgreSqlStatements = arrayOf(
              """
              |REPLACE INTO RepEntity(rePrimaryKey, reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean)
              |                       VALUES (NEW.rePrimaryKey, NEW.reLastChangedBy, NEW.reLastChangeTime, NEW.reNumField, NEW.reString, NEW.reBoolean)
              |                /*psql ON CONFLICT(rePrimaryKey) DO UPDATE
              |                   SET reLastChangedBy = EXCLUDED.reLastChangedBy,
              |                       reLastChangeTime = EXCLUDED.reLastChangeTime,
              |                       reNumField = EXCLUDED.reNumField,
              |                       reBoolean = EXCLUDED.reBoolean,
              |                       reString = EXCLUDED.reString
              |                       */
              |                       
              |            
              """.trimMargin(),
            ),
            conditionSql = "",
            conditionSqlPostgres = "",
          ),),
        ),
        50 to ReplicationEntityMetaData(tableId = 50, 
        entityTableName = "RepEntityWithAttachment", 
        receiveViewName = "RepEntityWithAttachment_ReceiveView", 
        entityPrimaryKeyFieldNames = listOf("waUid",),
        entityVersionIdFieldName = "waVersionId", 
        entityFields = listOf(
          ReplicationFieldMetaData(
            fieldName = "waVersionId",
            dbFieldType = -5,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "waAttachmentUri",
            dbFieldType = -1,
            nullable = true,
          ),
          ReplicationFieldMetaData(
            fieldName = "waMd5",
            dbFieldType = -1,
            nullable = true,
          ),
          ReplicationFieldMetaData(
            fieldName = "waSize",
            dbFieldType = 4,
            nullable = false,
          ),
          ReplicationFieldMetaData(
            fieldName = "waUid",
            dbFieldType = -5,
            nullable = false,
          ),
        )
        ,
        batchSize = 1_000,
        remoteInsertStrategy = ReplicateEntity.RemoteInsertStrategy.INSERT_INTO_RECEIVE_VIEW,
        triggers = listOf(
          Trigger(
            name = "repentwithattachment_remote_insert",
            order = Trigger.Order.INSTEAD_OF,
            events = arrayOf(Trigger.Event.INSERT,),
            on = Trigger.On.RECEIVEVIEW,
            sqlStatements = arrayOf(
              """
              |REPLACE INTO RepEntityWithAttachment(waUid, waVersionId, waAttachmentUri, waMd5, waSize)
              |                       VALUES (NEW.waUid, NEW.waVersionId, NEW.waAttachmentUri, NEW.waMd5, NEW.waSize)
              |                /*psql ON CONFLICT(waUid) DO UPDATE
              |                   SET waUid = EXCLUDED.waUid,
              |                       waVersionId = EXCLUDED.waVersionId,
              |                       waAttachmentUri = EXCLUDED.waAttachmentUri,
              |                       waMd5 = EXCLUDED.waMd5,
              |                       waSize = EXCLUDED.waSize
              |                       */
              |            
              """.trimMargin(),
            ),
            postgreSqlStatements = arrayOf(
              """
              |REPLACE INTO RepEntityWithAttachment(waUid, waVersionId, waAttachmentUri, waMd5, waSize)
              |                       VALUES (NEW.waUid, NEW.waVersionId, NEW.waAttachmentUri, NEW.waMd5, NEW.waSize)
              |                /*psql ON CONFLICT(waUid) DO UPDATE
              |                   SET waUid = EXCLUDED.waUid,
              |                       waVersionId = EXCLUDED.waVersionId,
              |                       waAttachmentUri = EXCLUDED.waAttachmentUri,
              |                       waMd5 = EXCLUDED.waMd5,
              |                       waSize = EXCLUDED.waSize
              |                       */
              |            
              """.trimMargin(),
            ),
            conditionSql = "",
            conditionSqlPostgres = "",
          ),),
        ),
        )
      }

}
